<template>
    <main-header />
    <!-- <sub-header
        heading="Shopping Cart"
        subHeading="Add your coupon code and save up to 70% on all purchases!"
    /> -->
    <section class="cart-section">
        <div class="container">
            <section v-if="cart.length > 0 || inProgressItems.length" class="cart-grid">
                <div class="cart-panels-wrapper">
                    <!-- IN PROGRESS Section -->
                    <div v-if="inProgressItems.length" class="cart-panel in-progress-panel">
                        <div class="section-header">
                            <h3>🔄 In Progress</h3>
                            <p class="section-subtitle">Complete your personalization to checkout</p>
                        </div>
                        <div class="cart-header-row">
                            <span class="col-product">Product Name</span>
                            <span class="col-status">Status</span>
                            <span class="col-actions">Actions</span>
                        </div>
                        <div class="divider"></div>
                        <div
                            class="cart-row in-progress-row"
                            v-for="(item, index) in inProgressItems"
                            :key="'progress-' + index"
                        >
                            <div class="product-cell">
                                <img
                                    :src="item.images && item.images.length > 0 ? item.images[0] : require('@/assets/images/empty-cart.svg')"
                                    :alt="item.brand"
                                    class="thumb"
                                />
                                <div class="product-meta">
                                    <div class="product-title">{{ item.brand }}</div>
                                    <span class="chip in-progress-chip">In Progress</span>
                                </div>
                            </div>
                            <div class="status-cell">
                                <span class="progress-info">Step {{ journeyForItem(item)?.step || 0 }} of 3</span>
                            </div>
                            <div class="actions-cell">
                                <button
                                    class="btn-resume"
                                    @click="continueJourney(journeyForItem(item)?.productId || item.productId)"
                                >Resume</button>
                                <button class="btn-delete" @click="deleteInProgressItem(item)" aria-label="remove">Delete</button>
                            </div>
                        </div>
                        <div class="divider"></div>
                    </div>

                    <!-- FINISHED Section -->
                    <div v-if="finishedItems.length" class="cart-panel finished-panel">
                        <div class="section-header">
                            <h3>✓ Ready to Checkout</h3>
                            <p class="section-subtitle">Your completed personalizations</p>
                        </div>
                        <div class="cart-header-row">
                            <span class="col-product">Product Name</span>
                            <span class="col-status"></span>
                            <span class="col-qty">Quantity</span>
                            <span class="col-price">Price</span>
                        </div>
                        <div class="divider"></div>
                        <div
                            class="cart-row"
                            v-for="(item, index) in finishedItems"
                            :key="'finished-' + index"
                        >
                        <div class="product-cell">
                            <img
                                :src="item.images && item.images.length > 0 ? item.images[0] : require('@/assets/images/empty-cart.svg')"
                                :alt="item.brand"
                                class="thumb"
                            />
                            <div class="product-meta">
                                <div class="product-title">{{ item.brand }}<span v-if="item.size"> ({{ item.size }})</span></div>
                                <span class="chip in-stock">In Stock</span>
                            </div>
                        </div>
                        <div class="status-cell">
                            <template v-if="journeyForItem(item)">
                                <template v-if="journeyForItem(item).isComplete">
                                    <span class="chip completed">Completed</span>
                                </template>
                                <template v-else>
                                    <button
                                        class="chip action"
                                        @click="continueJourney(journeyForItem(item).productId || item.productId)"
                                    >Continue Journey</button>
                                </template>
                            </template>
                        </div>
                        <div class="qty-cell">
                            <div class="qty-control" v-if="item._type !== 'journey'">
                                <button
                                    class="qty-btn"
                                    aria-label="decrease"
                                    @click="changeQuantity(item, -1)"
                                >-</button>
                                <span class="qty-value">{{ item.quantity }}</span>
                                <button
                                    class="qty-btn"
                                    aria-label="increase"
                                    @click="changeQuantity(item, 1)"
                                >+</button>
                            </div>
                            <div class="qty-control" v-else style="opacity:.5; pointer-events:none;">
                                <button class="qty-btn" aria-label="decrease">-</button>
                                <span class="qty-value">1</span>
                                <button class="qty-btn" aria-label="increase">+</button>
                            </div>
                        </div>
                        <div class="price-cell">
                            {{ item.currency }} {{ item.price.toFixed(2) }}
                            <span v-if="item.oldPrice" class="old-price">{{ item.currency }}{{ Number(item.oldPrice).toFixed(2) }}</span>
                        </div>
                        <button v-if="item._type !== 'journey'" class="trash" @click="deleteFinishedItem(index)" aria-label="remove">✕</button>
                        <button v-else class="trash" @click="deleteJourney(item.productId)" aria-label="remove">✕</button>
                    </div>
                    <div class="divider"></div>
                    </div>
                </div>

                <aside class="summary-panel">
                    <h3 class="summary-title">Order Summary</h3>
                    <div class="summary-row">
                        <span>Subtotal</span>
                        <span>{{ currency }} {{ adjustedSubtotal.toFixed(2) }}</span>
                    </div>
                    <div class="summary-row" v-if="portraitStyleFee > 0">
                        <span>Portrait Style Add-on</span>
                        <span>{{ currency }} {{ portraitStyleFee.toFixed(2) }}</span>
                    </div>
                    <div class="summary-row" v-if="calculatedDiscount > 0">
                        <span>Discount</span>
                        <span>-{{ currency }} {{ calculatedDiscount.toFixed(2) }}</span>
                    </div>
                    <div class="summary-row">
                        <span>Delivery Fee</span>
                        <span>
                            <template v-if="calculatedDeliveryFee === 0">
                                FREE
                            </template>
                            <template v-else>
                                Calculated at checkout
                            </template>
                        </span>
                    </div>
                    <div class="summary-divider"></div>
                    <div class="summary-row total">
                        <span>Total</span>
                        <span>{{ currency }} {{ total.toFixed(2) }}</span>
                    </div>
                    <router-link v-if="canCheckout" to="/checkout" class="checkout-link">
                        <action-button btnvalue="PROCEED TO CHECKOUT" style="--dim-blue: #e37267" />
                    </router-link>
                    <div v-else class="checkout-disabled">
                        <action-button :disabled="true" btnvalue="PROCEED TO CHECKOUT" style="--dim-blue: #e37267; opacity: .6; cursor: not-allowed;" />
                        <p class="hint">Please complete your personalization journey to checkout.</p>
                    </div>
                </aside>
            </section>
            <div class="no-cart" v-else>
                <div class="no-cart-text">
                    <img
                        src="@/assets/images/empty-cart.svg"
                        alt="empty-cart"
                    />
                    <h3>Your cart is empty!</h3>
                    <p>Browse our shop and discover our latest products.</p>
                </div>
                <router-link to="/shop">
                    <action-button btnvalue="Start Shopping" />
                </router-link>
            </div>
        </div>
    </section>
    <main-footer />
</template>

<script>
import SubHeader from "@/components/SubHeader.vue";
import ActionButton from "@/components/ActionButton.vue";
import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
    components: { SubHeader, ActionButton, MainHeader, MainFooter },
    name: "CartView",
    data() {
        return {
            discount: 40,
            deliveryFee: 18,
            currency: "$",
            isFirstPurchase: false,
        };
    },
    mounted() {
        this.$store.dispatch('checkFirstTimeBuyer').then(res => {
            this.isFirstPurchase = res;
        });
        
        // Check for payment status in URL (cancelled or failed)
        const urlParams = new URLSearchParams(window.location.search);
        const paymentStatus = urlParams.get('payment');
        
        if (paymentStatus === 'cancelled') {
            this.$swal({
                icon: 'warning',
                title: 'Payment Cancelled',
                text: 'Your payment was cancelled. Your cart items are still here if you want to try again.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#e37267',
            });
            // Clean URL
            window.history.replaceState({}, document.title, window.location.pathname);
        } else if (paymentStatus === 'failed') {
            this.$swal({
                icon: 'error',
                title: 'Payment Failed',
                text: 'Your payment could not be processed. Please check your payment details and try again.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#d33',
            });
            // Clean URL
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    },
    methods: {
        ...mapActions(["delete_item", "update_quantity", "delete_journey"]),
        getJourneyForCartItem(item) {
            if (!item) return null;
            const productId = item.productId || item._id;
            if (!productId) return null;
            const journey = typeof this.getJourneyByProductId === 'function'
                ? this.getJourneyByProductId(productId)
                : null;
            if (journey) return journey;
            return this.journeys ? this.journeys[productId] : null;
        },
        getPortraitStyleCountForCartItem(item) {
            if (!item) return 0;
            const journey = this.getJourneyForCartItem(item);
            
            // Priority 1: Use the pre-calculated count from journey metadata (persisted in localStorage)
            if (journey && typeof journey.portraitStyleCount === 'number') {
                return journey.portraitStyleCount;
            }

            // Priority 2: Try to calculate from detailed product data (only works if full data is loaded)
            const journeyProducts = this.getJourneyProducts(journey);
            const directProducts = this.getJourneyProducts(item);
            const products = journeyProducts.length ? journeyProducts : directProducts;
            if (products.length) {
                return products.reduce(
                    (count, product) => count + (this.productHasPortraitStyle(product) ? 1 : 0),
                    0
                );
            }
            
            // Priority 3: Check item-level flag
            return item.portraitStyle ? 1 : 0;
        },
        getJourneyProducts(source) {
            if (!source || typeof source !== 'object') return [];
            if (Array.isArray(source.setProducts) && source.setProducts.length) {
                return source.setProducts;
            }
            if (Array.isArray(source.fullControlSets) && source.fullControlSets.length) {
                return source.fullControlSets;
            }
            return [];
        },
        productHasPortraitStyle(product) {
            if (!product || typeof product !== 'object') return false;
            if (product.portraitStyle) return true;
            if (product.userSelections?.portraitStyle) return true;
            if (Array.isArray(product.personalization)) {
                return product.personalization.some((entry) =>
                    this.personalizationEntryHasPortraitStyle(entry)
                );
            }
            return false;
        },
        personalizationEntryHasPortraitStyle(entry) {
            if (!entry || !entry.input) return false;
            const input = entry.input;
            if (Array.isArray(input)) {
                return input.some((inputItem) => !!inputItem?.portraitStyle);
            }
            if (typeof input === 'object') {
                if (input.portraitStyle) return true;
            }
            return false;
        },
        deleteInProgressItem(item) {
            try {
                if (item && item.productId) {
                    this.delete_journey(item.productId);
                }
            } catch (e) {
                console.error('Error deleting in-progress item:', e);
            }
        },
        deleteFinishedItem(index) {
            try {
                const item = this.finishedItems[index];
                if (item && item.productId) {
                    this.delete_journey(item.productId);
                }
                // Find the actual index in the full cart
                const cartIndex = this.cart.findIndex(c => c._id === item._id);
                if (cartIndex !== -1) {
                    this.delete_item(cartIndex);
                }
            } catch (e) {
                console.error('Error deleting finished item:', e);
            }
        },
        changeQuantity(item, delta) {
            const next = Math.max(1, Math.min(10, (item.quantity || 1) + delta));
            if (next === item.quantity) return;
            this.update_quantity({ _id: item._id, size: item.size, quantity: next });
        },
        continueJourney(productId) {
            const j = this.getJourneyByProductId && this.getJourneyByProductId(productId);
            const type = j?.journeyType || 'set';
            if (type === 'item') {
                this.$router.push(`/item/${productId}`);
            } else {
                this.$router.push(`/personalization/${productId}`);
            }
        },
        deleteJourney(productId) {
            this.delete_journey(productId);
        },
        journeyForItem(item) {
            // For cart rows (non-journey), only match by exact productId to avoid mixing different journeys of same name
            if (item && item._type !== 'journey') {
                return this.getJourneyByProductId && this.getJourneyByProductId(item.productId);
            }
            // For synthetic journey rows, item.productId is exactly the journey id
            if (item && item._type === 'journey') {
                return this.getJourneyByProductId && this.getJourneyByProductId(item.productId);
            }
            return null;
        },
    },
    computed: {
        ...mapState(["cart", "products", "journeys"]),
        ...mapGetters(["subtotal", "hasIncompleteJourneys", "getJourneyByProductName", "getJourneyByProductId"]),
        portraitStyleFee() {
            if (!Array.isArray(this.cart)) return 0;
            return this.cart.reduce((sum, item) => {
                const perUnitPortraits = this.getPortraitStyleCountForCartItem(item);
                if (!perUnitPortraits) return sum;
                const qty = item?.quantity || 1;
                return sum + perUnitPortraits * qty * 5;
            }, 0);
        },
        adjustedSubtotal() {
            return this.subtotal + this.portraitStyleFee;
        },
        inProgressItems() {
            // Build synthetic rows for unfinished journeys
            const cartIds = new Set((this.cart || []).map((c) => c.productId).filter(Boolean));
            const journeyRows = Object.values(this.journeys || {})
                .filter((j) => j && j.productId)
                .filter((j) => !j.isComplete && !cartIds.has(j.productId))
                .map((j) => ({
                    _type: 'journey',
                    productId: j.productId,
                    brand: j.productName,
                    images: [require('@/assets/images/empty-cart.svg')],
                    price: 0,
                    currency: '$',
                    quantity: 1,
                }));
            return journeyRows;
        },
        finishedItems() {
            // Show all cart items that are ready for checkout
            // This includes items with completed journeys OR items added directly to cart
            return (this.cart || []).filter(item => {
                const journey = this.journeyForItem(item);
                // Show if: no journey (direct add), or journey is complete
                return !journey || journey.isComplete;
            });
        },
        displayRows() {
            // Build synthetic rows for unfinished journeys whose product is not in cart
            const cartIds = new Set((this.cart || []).map((c) => c.productId).filter(Boolean));
            const journeyRows = Object.values(this.journeys || {})
                .filter((j) => j && j.productId) // drop invalid/null ids
                .filter((j) => !j.isComplete && !cartIds.has(j.productId))
                .map((j) => ({
                    _type: 'journey',
                    productId: j.productId,
                    brand: j.productName,
                    images: [require('@/assets/images/empty-cart.svg')],
                    price: 0,
                    currency: '$',
                    quantity: 1,
                }));
            // When a journey is complete AND exists in cart, prefer the cart row which will show Completed
            return [...(this.cart || []), ...journeyRows];
        },
        total() {
            return Math.max(0, this.adjustedSubtotal - this.calculatedDiscount + this.calculatedDeliveryFee);
        },
        canCheckout() {
            return !this.hasIncompleteJourneys;
        },
        calculatedDiscount() {
             // First time purchase gets 10% discount
            if (this.isFirstPurchase) {
                return this.adjustedSubtotal * 0.10;
            }
            return 0;
        },
        calculatedDeliveryFee() {
            const totalAfterDiscount = this.adjustedSubtotal - this.calculatedDiscount;
            // If price (after discount) is under $49, shipping cost applies ($18). 
            // If >= $49, Free Shipping.
            if (totalAfterDiscount >= 49) {
                return 0;
            }
            return 18;
        }
    },
};
</script>

<style scoped>
.cart-section {
    background: #fffef9;
    padding-bottom: 3rem;
}

.cart-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
}

@media (min-width: 1200px) {
    .cart-grid {
        grid-template-columns: minmax(0, 1fr) 380px;
    }
}

.cart-panel {
    border: 1.5px solid #e37267;
    border-radius: 15px;
    padding: 1.5rem 1.5rem 0.75rem;
    background: #fffef9;
}

.cart-header-row {
    display: grid;
    grid-template-columns: 1fr;
    color: #e4b9a0;
    font-weight: 600;
    margin-bottom: 0.75rem;
    row-gap: 0.6rem;
}

@media (min-width: 768px) {
    .cart-header-row {
        grid-template-columns: minmax(0, 1fr) 180px 180px 140px;
        row-gap: 0;
    }
}

.divider {
    height: 1px;
    background: #e6d1c7;
    margin: 0.75rem 0 0.5rem;
}

.cart-row {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    gap: 1rem;
    padding: 1rem 0;
}

@media (min-width: 768px) {
    .cart-row {
        grid-template-columns: minmax(0, 1fr) 180px 180px 140px 32px;
        align-items: center;
    }
}

.product-cell {
    display: grid;
    grid-template-columns: 90px 1fr;
    align-items: center;
    gap: 1rem;
}

.thumb {
    width: 90px;
    height: 88px;
    border-radius: 10px;
    object-fit: cover;
}

.product-meta {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.product-title {
    font-weight: 600;
    font-size: 20px;
}

.chip {
    display: inline-flex;
    align-items: center;
    height: 20px;
    padding: 0 10px;
    border-radius: 10px;
    font-size: 13.28px;
}
.in-stock {
    background: #ffe9dd;
    color: #e37267;
    align-self: flex-start; /* don't stretch to full width in flex column */
    white-space: nowrap; /* keep pill tight to text */
}
.action {
    background: #ffeee5;
    color: rgba(168,98,91,0.9);
    border: none;
    cursor: pointer;
}
.completed {
    background: #ffe9dd;
    color: #e37267;
}

.qty-cell {
    display: flex;
    justify-content: center;
}

.qty-control {
    display: inline-flex;
    align-items: center;
    border: 2px solid #d78d86;
    border-radius: 20px;
    padding: 4px 10px;
    min-width: 100px;
    justify-content: space-between;
}
.qty-btn {
    background: transparent;
    color: #d78d86;
    border: none;
    font-size: 22.4px;
    line-height: 1;
    cursor: pointer;
}
.qty-value {
    color: #d78d86;
    font-weight: 900;
}

.price-cell {
    text-align: right;
    font-weight: 600;
    font-size: 20px;
}
.status-cell {
    display: flex;
    justify-content: center;
}
.old-price {
    color: #d78d86;
    text-decoration: line-through;
    margin-left: 10px;
    font-weight: 400;
    opacity: 0.8;
}

.trash {
    border: none;
    background: #fffef9;
    cursor: pointer;
    font-size: 17.6px;
}

.summary-panel {
    border: 2px solid #e37267;
    border-radius: 20px;
    padding: 28px;
    background: linear-gradient(135deg, #fffef9 0%, #fff5f0 100%);
    box-shadow: 0 4px 16px rgba(227, 114, 103, 0.12);
    height: fit-content;
}
.summary-title {
    color: #e37267;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1rem;
}
.summary-row {
    display: flex;
    justify-content: space-between;
    font-size: 1.5rem;
    padding: 8px 0;
}
.summary-divider {
    height: 1px;
    background: #e6d1c7;
    margin: 1.2rem 0;
}
.total span:last-child {
    font-size: 2rem;
    font-weight: 700;
}
.checkout-link {
    display: block;
    margin-top: 1.6rem;
}
.checkout-link button {
    width: 100%;
    padding: 16px 24px;
    border-radius: 999px;
    border: none;
    background: linear-gradient(135deg, #e37267, #f4a89f);
    color: #ffffff;
    font-weight: 600;
    font-size: 1.6rem;
    box-shadow: 0 4px 12px rgba(227, 114, 103, 0.3);
    cursor: pointer;
}
.checkout-link button:hover {
    box-shadow: 0 6px 18px rgba(227, 114, 103, 0.4);
}
.checkout-disabled .hint {
    font-size: 1.3rem;
    color: #9d8484;
    margin-top: 0.8rem;
}

.recommend-section {
    margin-top: 3rem;
}
.recommend-title {
    color: #e37267;
    font-size: 1.67vw;
    margin-bottom: 1rem;
}
.recommend-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
}
.card {
    box-shadow: 0 4px 4px rgba(168, 98, 91, 0.2);
    border-radius: 5px;
    overflow: hidden;
    background: #ffffff;
}
.card-img {
    width: 100%;
    height: 210px;
    object-fit: cover;
}
.card-body {
    padding: 1rem;
    display: grid;
    gap: 0.6rem;
}
.card-title {
    font-weight: 600;
}
.price {
    font-size: 0.97vw;
}
.no-cart {
    display: grid;
    place-items: center;
    gap: 30px;
}

.no-cart-text {
    text-align: center;
}

.no-cart img {
    height: 150px;
    width: 30%;
}

.cart-details {
    overflow-x: auto;
}
.img {
    height: 70px;
    width: 70px;
    margin-inline: auto;
    object-fit: contain;
}

/* legacy table styles removed (replaced by grid layout) */

/* Tablet (iPad) optimizations */
@media (max-width: 1024px) {
    /* Use a single-column layout so the summary panel stacks below */
    .cart-grid {
        grid-template-columns: 1fr;
        gap: 1.2rem;
    }
    /* Slightly tighter panel padding on tablet */
    .summary-panel {
        padding: 1.5rem;
    }
    /* Make the page container wider on tablet to reduce side gutters */
    .container {
        width: 95%;
        margin-inline: auto;
        padding: 0 16px;
    }
}

@media (max-width: 699px) {
    .cart-grid {
        grid-template-columns: 1fr;
    }
    .recommend-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 699px) {
    /* Header labels compact like Figma */
    .cart-header-row {
        grid-template-columns: 1fr minmax(88px, 26vw) minmax(64px, 20vw) 24px; /* product | qty | price | spacer for trash */
        gap: 0.6rem;
        font-size: 4.2vw;
    }
    .cart-header-row .col-status { display: none; }
    .cart-header-row .col-price { text-align: right; }

    /* Row layout: product left, status below product; qty, price, trash on the right */
    .cart-row {
        grid-template-columns: 1fr minmax(88px, 26vw) minmax(64px, 20vw) 24px; /* product | qty | price | delete */
        grid-template-rows: auto auto; /* status under product */
        align-items: start;
        gap: 0.6rem;
        padding: 0.8rem 0;
    }
    .product-cell {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
        grid-template-columns: 60px 1fr; /* smaller thumbnail */
        gap: 0.6rem;
    }
    .status-cell {
        grid-column: 1 / 2;
        grid-row: 2 / 3;
        justify-content: flex-start;
    }
    .qty-cell {
        grid-column: 2 / 3;
        grid-row: 1 / 3;
        align-self: center;
    }
    .price-cell {
        grid-column: 3 / 4;
        grid-row: 1 / 3;
        align-self: center;
        font-size: 3.8vw;
    }
    .trash {
        grid-column: 4 / 5;
        grid-row: 1 / 3;
        align-self: start;
        font-size: 3.8vw;
    }

    .thumb {
        width: 60px;
        height: 58px;
        border-radius: 10px;
        object-fit: cover;
    }
    .product-title { font-size: 3.2vw; }
    .chip { height: 18px; font-size: 3vw; }
    .qty-control { min-width: 84px; padding: 2px 8px; }
    .qty-btn { font-size: 4.2vw; }
    .qty-value { font-size: 3.2vw; }

    .summary-panel { padding: 1.2rem; }
    .summary-title { font-size: 5.3vw; }
    .summary-row { font-size: 4.2vw; }

    /* Make the page container full-width on mobile to avoid overflow */
    .container {
        width: 100%;
        margin-inline: 0;
        padding: 0 12px;
    }

    /* Slightly reduce inner padding for tighter fit */
    .cart-panel {
        padding: 12px 12px 8px;
    }

    /* Let long product names wrap instead of widening the grid */
    .product-title {
        word-break: break-word;
    }
    .total span:last-child {
        font-size: 4.53vw;
        font-weight: 700;
    }
}

@media (max-width: 480px) {
    .recommend-grid { grid-template-columns: 1fr; }
}

/* New Styles for In Progress and Finished Sections */
.cart-panels-wrapper {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.section-header {
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #e37267;
}

.section-header h3 {
    margin: 0 0 0.5rem 0;
    color: #e37267;
    font-size: 24px;
    font-weight: 700;
}

.section-subtitle {
    margin: 0;
    color: #999;
    font-size: 14px;
}

.in-progress-panel {
    background: linear-gradient(135deg, #fff9f5 0%, #fffef9 100%);
    border-color: #f59e0b;
}

.finished-panel {
    background: linear-gradient(135deg, #f0fdf4 0%, #fffef9 100%);
    border-color: #10b981;
}

.in-progress-row {
    grid-template-columns: 1fr 150px 200px !important;
}

@media (max-width: 768px) {
    .in-progress-row {
        grid-template-columns: 1fr !important;
    }
}

.in-progress-chip {
    background: #fef3c7;
    color: #f59e0b;
}

.progress-info {
    color: #666;
    font-size: 14px;
    font-weight: 500;
}

.actions-cell {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

.btn-resume {
    padding: 8px 16px;
    background: #e37267;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-resume:hover {
    background: #d66259;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(227, 114, 103, 0.3);
}

.btn-delete {
    padding: 8px 16px;
    background: transparent;
    color: #ef4444;
    border: 2px solid #ef4444;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-delete:hover {
    background: #ef4444;
    color: white;
}

.col-actions {
    text-align: right;
}

@media (max-width: 768px) {
    .actions-cell {
        justify-content: flex-start;
        margin-top: 1rem;
    }
}

@media (max-width: 390px) {
    /* Tighter columns for small screens (iPhone SE) */
    .cart-header-row,
    .cart-row {
        grid-template-columns: 1fr minmax(70px, 20vw) minmax(50px, 18vw) 20px !important;
        gap: 0.4rem !important;
    }
    
    .product-cell {
        grid-template-columns: 50px 1fr !important;
        gap: 0.5rem !important;
    }

    .thumb {
        width: 50px !important;
        height: 50px !important;
    }

    .product-title {
        font-size: 14px !important;
    }

    .chip {
        font-size: 11px !important;
        height: 16px !important;
    }

    .qty-control {
        min-width: 60px !important;
        padding: 2px 4px !important;
    }
    
    .qty-btn {
        font-size: 16px !important;
    }
    
    .qty-value {
        font-size: 13px !important;
    }

    .price-cell {
        font-size: 13px !important;
    }
    
    .trash {
        font-size: 14px !important;
    }
    
    /* Adjust header specifically if needed */
    .cart-header-row {
        font-size: 13px !important;
    }
}
</style>